import React from "react";

export default function DashboardIcon() {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.49414 4.5415V20.4372H21.2545" stroke="#4F6E90" strokeWidth="2.27082" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path d="M11.0352 15.8954V9.28335M15.0091 15.8954V5.67676M18.983 15.8954V9.28335" stroke="#354F6C"
                  strokeWidth="2.27082" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>


    );
}
